
import React from 'react';
import { Button } from '@/components/ui/button';
import { Mail, Phone, ArrowRight } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const FinalCTA: React.FC = () => {
  const navigate = useNavigate();
  
  const handleServicesClick = () => {
    navigate('/services#subscription-services');
  };
  
  return (
    <section className="py-16 bg-gradient-to-br from-[#0B1939] to-[#081631] text-white">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-3xl sm:text-4xl font-bold mb-6">
            Ready to transform your business with Workflow Intelligence?
          </h2>
          <p className="text-lg text-gray-300 mb-10 max-w-2xl mx-auto">
            Contact us today to get started with a free consultation. We'll help you identify the right AI solutions for your specific business needs.
          </p>
          
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Button 
              variant="outline" 
              className="bg-transparent border-white text-white hover:bg-white hover:text-brand-navy flex items-center gap-2"
              onClick={() => window.location.href = 'tel:+64212763763'}
            >
              <Phone className="h-5 w-5" />
              <span>Call Us Now</span>
            </Button>
            
            <Button 
              variant="outline" 
              className="bg-transparent border-white text-white hover:bg-white hover:text-brand-navy flex items-center gap-2"
              onClick={() => window.location.href = 'mailto:connect@thinktomorrow.ai'}
            >
              <Mail className="h-5 w-5" />
              <span>Email Us</span>
            </Button>
            
            <Button 
              variant="primary" 
              className="flex items-center gap-2"
              onClick={handleServicesClick}
            >
              <span>View Services</span>
              <ArrowRight className="h-5 w-5" />
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FinalCTA;
